import DOMParser from '../domparser'
import Store from '../../../store'
import { shallowReactive, defineAsyncComponent } from 'vue'
import { createView } from 'nette-base-module/js/views'

const templateCompatible = 'content' in document.createElement('template')

const $controls = new Proxy(
  {},
  {
    get: function(target, prop) {
      const controlName = prop
      if (typeof target[controlName] === 'undefined') {
        target[controlName] = new Proxy(
          {},
          {
            get: function(target, prop) {
              return Store.state.nette.$controls[controlName][prop]
            },
            set: function(target, prop, value) {
              Store.commit('nette/updateControl', {
                controlName: controlName,
                data: value,
                key: prop
              })

              return true
            }
          }
        )
      }

      return target[controlName]
    },
    set: function(target, prop, value) {
      Store.commit('nette/updateControl', {
        controlName: prop,
        data: value
      })

      return true
    }
  }
)

export default function InstallVueRender(NetteAjax) {
  return NetteAjax.ext(
    'vue-render',
    {
      init() {
        console.timeEnd('stinit')
        if (window.netteInitialState && window.netteInitialState.presenter) {
          window.netteInitialState.snippets = {}
          window.netteInitialState.snippets[
            this.rootElementId
          ] = this.rootElement

          this.render(
            window.netteInitialState,
            window.netteInitialState.presenter.template
              ? window.netteInitialState.presenter.template
              : false
          )

          const route = this.ext('vue-router').urlToRoute(window.location.href)
          const fullPath = this.ext('vue-router').routeToUrl(route)

          this.ext('vue-router').req[
            fullPath
          ] = new Promise(resolve => {
            resolve({
              data: window.netteInitialState,
              finalize: () => {
                this.render(window.netteInitialState, window.netteInitialState?.presenter?.template ? window.netteInitialState.presenter.template : false)
              },
            })
          })

          this.req[window.netteInitialState.state?.snippetName || 'Content'] = {
            url: window.location.pathname + window.location.search
          }
          console.log('init', this.req)

          // clean root element cache
          // this.rootElement = null
        }
      },
      before() {
        this.renderCnt++
      },
      success: function(payload, response, settings) {
        payload.data = {
          ...(payload.$data || {}),
          ...(settings.linkData && settings.linkData.$data
            ? settings.linkData.$data
            : {})
        }

        this.render(
          payload,
          (!settings.off || settings.off.indexOf('cache') === -1) &&
            payload.presenter.template
            ? payload.presenter.template
            : false
        )

        if (
          payload.state &&
          (settings.route ||
            (payload.state?.snippetName &&
              payload.state.snippetName !== 'Content'))
        ) {
          this.req[
            payload.state?.snippetName ? payload.state.snippetName : 'Content'
          ] = { ...settings }
        }

        this.renderCnt--
        if (this.renderCnt === 0 && this.after.length) {
          this.after.forEach(clb => {
            clb()
          })
          this.after = []
        }
      }
    },
    {
      // root element
      rootElement: null,
      // root element
      rootElementId: null,
      // snippetId => [startTag, endTag]
      snippetsTags: {},
      // components cache
      snippetsCache: {},
      // components cache off
      snippetsCacheOff: {},
      // snippets components
      $snippets: {},
      // after render callbacks
      after: [],
      // render counter
      renderCnt: 0,
      // object snippetName => ajax request
      req: {},

      onAfter(clb) {
        if (this.renderCnt === 0) {
          clb()
        } else {
          this.after.push(clb)
        }
      },

      install(Vue, context) {
        this.init(context.rootElementId)
        const self = this
        Vue.mixin({
          beforeCreate() {
            this.$snippets = self.$snippets
            this._snippetName = Store.state.nette.snippetName
            //this.$controls = Store.state.nette.$controls
            this.$controls = $controls
          },
          methods: {
            netteReload(cacheOff = true) {
              const req = {
                url: self.req[this._snippetName].url
              }

              if (self.req[this._snippetName].nette) {
                // req.nette = self.req[this._snippetName].nette
              }

              if (cacheOff) {
                req.off = ['cache']
              } else if (self.req[this._snippetName].off) {
                req.off = self.req[this._snippetName].off
              }
              NetteAjax.ajax(req)
            }
          },
          computed: {
            $presenter() {
              return Store.state.nette.$data[this._snippetName]
            },
            $presenterInfo() {
              return Store.state.nette.$presenter[this._snippetName]
            }
          }
        })
      },

      init(rootElementId) {
        console.time('stinit')
        this.rootElementId = rootElementId
        // add root component to observable components list
        this.$snippets[this.rootElementId] = null
        this.$snippets = shallowReactive(this.$snippets)

        // save root tag definition
        // this.saveSnippetTag(this.rootElementId, this.rootElement)

        // do a first render
        if (window.netteInitialState && window.netteInitialState.presenter) {
          // save root element
          this.rootElement = document.getElementById(
           this.rootElementId
          ).innerHTML

          this.req.Content = {
            url: window.location.pathname + window.location.search
          }
        }
      },

      _getInnerSnippetDepth(parent, tplParents, innerSnippets) {
        let depth = 0
        let tplParentI = tplParents.length - 1
        let parentSnippetId = null

        // lets find closest snippet parent
        do {
          parent = parent.parentNode
          if (tplParentI > -1 && parent instanceof DocumentFragment) {
            parent = tplParents[tplParentI]
            tplParentI--
          }

          if (
            (parentSnippetId = parent.getAttribute('id')) &&
            parentSnippetId.substr(0, 8) === 'snippet-'
          ) {
            depth++
            if (parentSnippetId in innerSnippets) {
              return innerSnippets[parentSnippetId][0] + depth
            }
          }
        } while (parent.tagName !== 'BODY')
        return depth
      },

      _findInnerSnippets(
        htmlDoc,
        tplParents = [],
        innerSnippets = {},
        templates = []
      ) {
        htmlDoc.querySelectorAll('[id^="snippet-"]').forEach(snippet => {
          // innerSnippetId
          const innerSnippetId = snippet.getAttribute('id')
          // save snippet tag
          this.saveSnippetTag(innerSnippetId, snippet)
          // save snippet depth
          innerSnippets[innerSnippetId] = [
            this._getInnerSnippetDepth(snippet, tplParents, innerSnippets),
            snippet
          ]
        })

        ;[].forEach.call(templates, tplTag => {
          this._findInnerSnippets(
            tplTag.content,
            tplParents.concat(tplTag.parentNode),
            innerSnippets
          )
        })

        return innerSnippets
      },

      _parseSnippets(snippets, find = []) {
        const templates = {}
        // find = find.length ? find : Object.keys(snippets)/*.filter((id) => { Object.prototype.hasOwnProperty.call(snippets, id) })*/
        for (const k in snippets) {
          const innerSnippets = {}
          const found = find.filter(
            id => k === id || snippets[k].indexOf('id="' + id + '"') !== -1
          )

          if (found.length) {
            const snippetHtml = new DOMParser().parseFromString(
              snippets[k],
              'text/html'
            )
            const templatesHtml = templateCompatible
              ? snippetHtml.getElementsByTagName('template')
              : []

            if (found.indexOf(k) !== -1) {
              // parse whole snippet
              this._findInnerSnippets(
                snippetHtml,
                [],
                innerSnippets,
                templatesHtml
              )
              innerSnippets[k] = [-1, snippetHtml.body]
            } else {
              // parse only parts of the snippet
              found.forEach(id => {
                if (!(id in innerSnippets)) {
                  let element = null
                  if ((element = snippetHtml.getElementById(id)) !== null) {
                    this._findInnerSnippets(
                      new DOMParser().parseFromString(
                        element.parentElement.innerHTML,
                        'text/html'
                      ),
                      [],
                      innerSnippets
                    )
                    return
                  }

                  // snippet can be in template :(
                  for (let i = 0; i < templatesHtml.length; i++) {
                    const tplTag = templatesHtml[i];
                    let element = null
                    if (
                      (element = tplTag.content.getElementById(id)) !== null
                    ) {
                      // console.log('templatesHtml', element, element.outerHTML)
                      this._findInnerSnippets(
                        new DOMParser().parseFromString(
                          element.outerHTML,
                          'text/html'
                        ),
                        [],
                        innerSnippets
                      )
                    }
                 }
                }
              })
            }

            Object.keys(innerSnippets)
              .sort((a, b) => {
                return innerSnippets[b][0] - innerSnippets[a][0]
              })
              .forEach(element => {
                const snippet = innerSnippets[element][1]
                templates[element] = this.snippetsTags[element]
                  ? this.snippetsTags[element][0] +
                    snippet.innerHTML +
                    this.snippetsTags[element][1]
                  : snippet.innerHTML

                if (element === k) {
                  return
                }

                // replace snippet tag with vue component only if its not root
                const vueComp = snippetHtml.createElement('component')
                vueComp.setAttribute(':is', "$snippets['" + element + "']")
                snippet.parentNode.replaceChild(vueComp, snippet)
              })
          }
        }

        return templates
      },

      render(payload, cacheKey = false) {
        // render(snippets = {}, defaultView = null, cacheKey = false) {
        const defaultView = payload.presenter
          ? payload.presenter.name + '.' + payload.presenter.action
          : null
        const data = {
          state: payload.state || null,
          presenter: payload.presenter || null
        }

        if (payload.$data) {
          data.$data = payload.$data
        }

        if (payload.$controls) {
          data.$controls = payload.$controls
        }

        if (payload.snippets && this.rootElementId in payload.snippets) {
          Store.dispatch('nette/replaceData', data)
        } else {
          Store.dispatch('nette/updateData', data)
        }

        if (!payload.snippets) {
          return
        }

        const snippets = payload.snippets
        console.log('Render snippets', {
          defaultView,
          cacheKey,
          snippets,
          cacheOff:
            cacheKey && cacheKey in this.snippetsCacheOff
              ? this.snippetsCacheOff[cacheKey]
              : []
        })
        console.time('render')

        const cacheOffSnippets =
          cacheKey && cacheKey in this.snippetsCacheOff
            ? this.snippetsCacheOff[cacheKey]
            : []
        let componentsTemplates = {}
        let components = {}
        const snippetsKeys = Object.keys(snippets)

        // create all components in snippets
        if (
          cacheKey === false ||
          !(cacheKey in this.snippetsCache) ||
          this.rootElementId in snippets
        ) {
          componentsTemplates = this._parseSnippets(snippets, snippetsKeys)
        } else {
          // use cached components
          const snippetsCacheKeys = Object.keys(this.snippetsCache[cacheKey])
          const parseSnippets = this.snippetsCacheOff[cacheKey]
          parseSnippets.push(
            ...snippetsKeys.filter(val => !snippetsCacheKeys.includes(val))
          )

          if (parseSnippets.length) {
            componentsTemplates = this._parseSnippets(snippets, parseSnippets)
          }

          components = this.snippetsCache[cacheKey]
        }

        for (const k in componentsTemplates) {
          let view = defaultView
          if (this.snippetsTags[k]) {
            if (this.snippetsTags[k][2] && cacheOffSnippets.indexOf(k) === -1)
              // disable cache for component
              cacheOffSnippets.push(k)

            if (this.snippetsTags[k][3])
              // use defined view for component
              view = this.snippetsTags[k][3]
          }

          // create component from template
          components[k] = this.createSnippetComponent(
            k,
            view,
            componentsTemplates[k]
          )
        }

        // update snippets
        for (const k in components) {
          this.$snippets[k] = components[k]
        }

        if (cacheKey) {
          this.snippetsCache[cacheKey] = {
            ...this.snippetsCache[cacheKey],
            ...components
          }
          this.snippetsCacheOff[cacheKey] = cacheOffSnippets
        }

        console.timeEnd('render') // this is little bit bullshit, because components are async...
      },

      isCacheOff(element) {
        const off = NetteAjax.getAjaxOff(element)
        return off !== null && off.indexOf('cache') !== -1
      },

      saveSnippetTag(snippetId, element) {
        const elStr = element.outerHTML
        this.snippetsTags[snippetId] = [
          elStr.substr(0, elStr.indexOf('>') + 1), // start tag
          '</' + element.nodeName.toLowerCase() + '>', // end tag
          this.isCacheOff(element), // is snippet template cache off
          element.getAttribute('data-view') // define view
        ]
      },

      createComputed() {
        const computed = {}

        for (const k in Store.state.nette.$data[
          Store.state.nette.snippetName
        ]) {
          computed[k] = function() {
            return this.$presenter[k]
          }
        }

        return computed
      },

      createSnippetComponent(snippet, view, template) {
        return defineAsyncComponent(
          () =>
            new Promise(resolve => {
              const component = { ...createView(view) }
              // const component = {}
              component.name = snippet
              component.template = template
              component.computed = {
                ...component.computed,
                ...this.createComputed()
              }
              resolve(component)
            })
        )
      }
    }
  )
}
